import { report } from '../utils/buryingPoint';

const VERSION = 'V1';
const PAGE_NAME = 'landing';

const FIELDS_MAP = {
  // formxx_click
  PHONE_CLICK: Symbol(),
  CODE_CLICK: Symbol(),
  CODE_VERIFY_CLICK: Symbol(),
  EMAIL_CLICK: Symbol(),
  STUDENT_NAME_CLICK: Symbol(),
  ENGLISH_NAME_CLICK: Symbol(),
  AGE_CLICK: Symbol(),
  SERVE_LANGUAGE_CLICK: Symbol(),
  STUDENT_CODE_CLICK: Symbol(),
  CUSTOM_INPUT_1_CLICK: Symbol(),
  CUSTOM_INPUT_2_CLICK: Symbol(),
  APP_SOURCE_SUBMIT_BUTTON_CLICK: Symbol(),
  SUBMIT_BUTTON_CLICK: Symbol(),
  AGREEMENT_CLICK: Symbol(),
  LEVITATION_BUTTON_CLICK: Symbol(),
  // formxx_click_user
  PHONE_CLICK_USER: Symbol(),
  CODE_CLICK_USER: Symbol(),
  CODE_VERIFY_CLICK_USER: Symbol(),
  EMAIL_CLICK_USER: Symbol(),
  STUDENT_NAME_CLICK_USER: Symbol(),
  ENGLISH_NAME_CLICK_USER: Symbol(),
  AGE_CLICK_USER: Symbol(),
  SERVE_LANGUAGE_CLICK_USER: Symbol(),
  STUDENT_CODE_CLICK_USER: Symbol(),
  CUSTOM_INPUT_1_CLICK_USER: Symbol(),
  CUSTOM_INPUT_2_CLICK_USER: Symbol(),
  APP_SOURCE_SUBMIT_BUTTON_CLICK_USER: Symbol(),
  SUBMIT_BUTTON_CLICK_USER: Symbol(),
  AGREEMENT_CLICK_USER: Symbol(),
  LEVITATION_BUTTON_CLICK_USER: Symbol(),
  // pc
  PC_LANDING_RESERVE_PV: Symbol(),
  PC_LANDING_RESERVE_UV: Symbol(),
  // mobile
  MOBILE_LANDING_RESERVE_PV: Symbol(),
  MOBILE_LANDING_RESERVE_UV: Symbol(),
  // others
  JUMP_OUT: Symbol(),
  SERVERSIDE_PV: Symbol(),
};

// https://wukongedu.feishu.cn/sheets/Z83asPXMxhMPZltJt7ycpefSnef?sheet=1bbe82 业务方约定的命名规范
const EVENT_NAMES_MAP = {
  // formxx_click
  [FIELDS_MAP.PHONE_CLICK]: 'g_FirstOrder_formPhone_Click',
  [FIELDS_MAP.CODE_CLICK]: 'g_FirstOrder_formCode_Click',
  [FIELDS_MAP.CODE_VERIFY_CLICK]: 'g_FirstOrder_formCodeVerify_Click',
  [FIELDS_MAP.EMAIL_CLICK]: 'g_FirstOrder_formEmail_Click',
  [FIELDS_MAP.STUDENT_NAME_CLICK]: 'g_FirstOrder_formStudentName_Click',
  [FIELDS_MAP.ENGLISH_NAME_CLICK]: 'g_FirstOrder_formEnglishName_Click',
  [FIELDS_MAP.AGE_CLICK]: 'g_FirstOrder_formAge_Click',
  [FIELDS_MAP.SERVE_LANGUAGE_CLICK]: 'g_FirstOrder_formServeLanguage_Click',
  [FIELDS_MAP.STUDENT_CODE_CLICK]: 'g_FirstOrder_formStudentCode_Click',
  [FIELDS_MAP.CUSTOM_INPUT_1_CLICK]: 'g_FirstOrder_formCustomInput1_Click',
  [FIELDS_MAP.CUSTOM_INPUT_2_CLICK]: 'g_FirstOrder_formCustomInput2_Click',
  [FIELDS_MAP.APP_SOURCE_SUBMIT_BUTTON_CLICK]: 'g_FirstOrder_formAppSourceSubmitButton_Click',
  [FIELDS_MAP.SUBMIT_BUTTON_CLICK]: 'g_FirstOrder_formSubmitButton_Click',
  [FIELDS_MAP.AGREEMENT_CLICK]: 'g_FirstOrder_formAgreement_Click',
  [FIELDS_MAP.LEVITATION_BUTTON_CLICK]: 'g_FirstOrder_formLevitationButton_Click',
  // formxx_click_user
  [FIELDS_MAP.PHONE_CLICK_USER]: 'g_FirstOrder_formPhone_ClickUser',
  [FIELDS_MAP.CODE_CLICK_USER]: 'g_FirstOrder_formCode_ClickUser',
  [FIELDS_MAP.CODE_VERIFY_CLICK_USER]: 'g_FirstOrder_formCodeVerify_ClickUser',
  [FIELDS_MAP.EMAIL_CLICK_USER]: 'g_FirstOrder_formEmail_ClickUser',
  [FIELDS_MAP.STUDENT_NAME_CLICK_USER]: 'g_FirstOrder_formStudentName_ClickUser',
  [FIELDS_MAP.ENGLISH_NAME_CLICK_USER]: 'g_FirstOrder_formEnglishName_ClickUser',
  [FIELDS_MAP.AGE_CLICK_USER]: 'g_FirstOrder_formAge_ClickUser',
  [FIELDS_MAP.SERVE_LANGUAGE_CLICK_USER]: 'g_FirstOrder_formServeLanguage_ClickUser',
  [FIELDS_MAP.STUDENT_CODE_CLICK_USER]: 'g_FirstOrder_formStudentCode_ClickUser',
  [FIELDS_MAP.CUSTOM_INPUT_1_CLICK_USER]: 'g_FirstOrder_formCustomInput1_ClickUser',
  [FIELDS_MAP.CUSTOM_INPUT_2_CLICK_USER]: 'g_FirstOrder_formCustomInput2_ClickUser',
  [FIELDS_MAP.APP_SOURCE_SUBMIT_BUTTON_CLICK_USER]: 'g_FirstOrder_formAppSourceSubmitButton_ClickUser',
  [FIELDS_MAP.SUBMIT_BUTTON_CLICK_USER]: 'g_FirstOrder_formSubmitButton_ClickUser',
  [FIELDS_MAP.AGREEMENT_CLICK_USER]: 'g_FirstOrder_formAgreement_ClickUser',
  [FIELDS_MAP.LEVITATION_BUTTON_CLICK_USER]: 'g_FirstOrder_formLevitationButton_ClickUser',
  // pc
  [FIELDS_MAP.PC_LANDING_RESERVE_PV]: 'g_pc_landing_Reserve_PV',
  [FIELDS_MAP.PC_LANDING_RESERVE_UV]: 'g_pc_landing_Reserve_UV',
  // mobile
  [FIELDS_MAP.MOBILE_LANDING_RESERVE_PV]: 'g_M_landing_Reserve_PV',
  [FIELDS_MAP.MOBILE_LANDING_RESERVE_UV]: 'g_M_landing_Reserve_UV',
  // others
  [FIELDS_MAP.JUMP_OUT]: 'g_FirstOrder_JumpOut',
  [FIELDS_MAP.SERVERSIDE_PV]: 'g_FirstOrder_ServerSide_PV',
};

const EVENT_NAME_MAP = {
  FIRSTORDER_FORMCODE_CLICK: 'G_FirstOrder_FormCode_Click',
  FIRSTORDER_FORMCODEVERIFY_CLICK: 'G_FirstOrder_formCodeVerify_Click',
  FIRSTORDER_FORMLANGUAGE_CLICK: 'G_FirstOrder_FormLanguage_Click',
  FIRSTORDER_FORMEMAIL_CLICK: 'G_FirstOrder_formEmail_Click',
  FIRSTORDER_FORMPHONE_CLICK: 'G_FirstOrder_FormPhone_Click',
  FIRSTORDER_FORMSTUDENTNAME_CLICK: 'G_FirstOrder_FormStudentName_Click',
  FIRSTORDER_FORMAGE_CLICK: 'G_FirstOrder_FormAge_Click',
  FIRSTORDER_FORMCUSTOMINPUT1_CLICK: 'G_FirstOrder_FormCustomInput1_Click',
  FIRSTORDER_FORMCUSTOMINPUT2_CLICK: 'G_FirstOrder_FormCustomInput2_Click',
  FIRSTORDER_LEVITATIONBUTTON_CLICK: 'G_FirstOrder_LevitationButton_Click',
  FIRSTORDER_SUBMITBUTTON_CLICK: 'G_FirstOrder_SubmitButton_Click',
  FIRSTORDER_SUBMITBUTTONLEADSID: 'G_FirstOrder_SubmitButtonLeadsId',
  FIRSTORDER_AGREEMENT_CLICK: 'G_FirstOrder_Agreement_Click',
  G_LOADING: 'G_LoadingDuration',
};

const doTrack = (field: symbol, options: any, repeat: boolean = false) => {
  const event = EVENT_NAMES_MAP[field];
  const { l, pageId } = options;

  report(
    `Track_${PAGE_NAME}_${pageId}_${VERSION}_${l}_${event}`,
    {
      ...options,
      event,
    },
    repeat,
  );
};

export default {
  FIELDS_MAP,
  doTrack,
  EVENT_NAME_MAP,
};
